import React from 'react'
import Config from '../launch/config'
import Box from '@mui/material/Box'

const ranks = {
    0: 'Cadet',
    1: 'Ensign',
    2: 'Commander',
    3: 'Captain',
}

const Rank = ({rank}) => {
    return (
        <Box sx={{ml: 1, display: 'flex'}}>
            {Object.keys(ranks).map((key, index) => {
                const filled = key <= rank
                return (
                    <Box
                        sx={{
                            m: '2px',
                            p: 1,
                            background: '#490ec0',
                            borderRadius: 1,
                            fontSize: 10,
                            opacity: filled ? 1 : 0.3,
                        }}
                    />
                )
            })}
        </Box>
    )
}

const ShipInfo = ({ship}) => {
    if (!ship) {
        return null
    }

    const {name, type} = ship

    return (
        <div>
            <h1 className="modal-heading">
                <span style={{color: `#${Config.colorGreen}`}}>{name}</span>{' '}
                <span className="modal-value">({type})</span>
            </h1>
            <Box sx={{m: 2, ml: 0, display: 'flex'}}>
                Rank:{' '}
                <Box sx={{ml: 1}} component="span">
                    {ranks[ship.rank]}
                </Box>
            </Box>
            <Box sx={{m: 2, ml: 0, display: 'flex'}}>
                Level: <Rank rank={ship.rank} />
            </Box>
        </div>
    )
}

export default ShipInfo
